import { createAction } from "@reduxjs/toolkit";

const SET_NOTIFICATION = "SET_NOTIFICATION@notification";
const RESET_NOTIFICATION = "RESET_NOTIFICATION@notification";

export const setNotification = createAction(SET_NOTIFICATION);

export const resetNotification = createAction(RESET_NOTIFICATION);
